import {Box, SvgIconProps, Typography} from "@mui/material";
import CreditCard from "./CreditCard";

interface FastPaymentsProps extends SvgIconProps {
    text1: string;
    text2: string;
}

export default function FastPayments(props: FastPaymentsProps) {
    const {viewBox, text1, text2, ...restProps} = props;
    return (
        <Box sx={{
            borderRadius: '50%',
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            height: '52px',
            width: '52px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            userSelect: 'none'
        }}>
            <CreditCard sx={{height: '19px', width: '19px', marginBottom: '3px'}}/>
            <Box sx={{marginBottom: '5px'}}>
                <Typography sx={{fontSize: '7px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.1}}>{text1.toUpperCase()}</Typography>
                <Typography sx={{fontSize: '7px', fontWeight: 'bold', textAlign: 'center', lineHeight: 1.1}}>{text2.toUpperCase()}</Typography> 
            </Box>
        </Box>
    );
}